import { createContext, useContext } from 'react';
import type { featureFlags } from '@common/feature-flags';

export type FeatureFlags = typeof featureFlags;

export const FeatureFlagsContext = createContext<FeatureFlags | null>(null);

export function useFeatureFlags() {
  const flags = useContext(FeatureFlagsContext);
  if (!flags) {
    throw new Error('FeatureFlagsContext not found');
  }

  return flags;
}
